// ** React Imports
import React, { Fragment, useState } from 'react';

// ** Styles
import '@styles/react/libs/flatpickr/flatpickr.scss';
import '@styles/react/pages/page-account-settings.scss';

import AllOrders from './AllOrders/AllOrders';
import DeliveredOrders from './DeliveredOrders/DeliveredOrders';
import PendingOrders from './PendingOrders/PendingOrders';
import ReadyToShip from './ReadyToShip/ReadyToShip';
import Shipped from './Shipped/Shipped';
import InTransit from './InTransit/InTransit';
import Unpaid from './Unpaid/Unpaid';
import ToBeReviewed from './ToBeReviewed/ToBeReviewed';
import Return from './Return/Return';
import Cancelled from './Cancelled/Cancelled';
import FailedDelivery from './FailedDelivery/FailedDelivery';
import UserTabs from '../../../components/UserPortalComponents/UserTabs/UserTabs';

const OrderTabs = () => {
  const tabs = ['All Orders', 'Pending', 'Ready to ship', 'Shipped', 'In transit', 'Delivered', 'Unpaid', 'To be reviewed', 'Return', 'Cancelled', 'Failed delivery'];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'All Orders':
        return <AllOrders />;
      case 'Pending':
        return <PendingOrders />;
      case 'Ready to ship':
        return <ReadyToShip />;
      case 'Shipped':
        return <Shipped />;
      case 'In transit':
        return <InTransit />;
      case 'Delivered':
        return <DeliveredOrders />;
      case 'Unpaid':
        return <Unpaid />;
      case 'To be reviewed':
        return <ToBeReviewed />;
      case 'Return':
        return <Return />;
      case 'Cancelled':
        return <Cancelled />;
      case 'Failed delivery':
        return <FailedDelivery />;
      default:
        return null;
    }
  };

  return (
    <Fragment>
      <div className="mx-md-3">
        <UserTabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} />
        {renderTabContent()}
      </div>
    </Fragment>
  );
};

export default OrderTabs;

